import { Upload } from "antd";
import classNames from "classnames";

const Component = ({
  children,
  handleFileUpload,
  onFileRemove,
  onUpload,
  listType,
  fillWidth,
  className,
  validTypes,
  ...rest
}) => {
  return (
    <div
      className={classNames("file-dragger--wrapper", {
        "file-dragger--wrapper-full": fillWidth,
      })}
    >
      <Upload
        className={classNames(className, {
          "file-dragger--upload-full": fillWidth,
        })}
        onChange={async (info) => {
          const fileList = await handleFileUpload(info);
          onUpload(fileList);
        }}
        listType={listType}
        onRemove={onFileRemove}
        accept={validTypes?.join(",")}
        validTypes={validTypes}
        {...rest}
      >
        {children}
      </Upload>
    </div>
  );
};

export default Component;
